import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DpDatePickerModule } from 'ng2-jalali-date-picker';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { PageComponent } from './page/page.component';
import { LoginComponent } from './components/login/login.component';
import { FormyComponent } from './components/formy/formy.component';
import { FieldComponent } from './components/formy/field/field.component';
// import { HomeComponent } from './home/home.component';
import { CmodalComponent } from './components/cmodal/cmodal.component';
import { MenuComponent } from './components/menu/menu.component';
import { GridComponent } from './components/grid/grid.component';
import { ColumnComponent } from './components/grid/column/column.component';
import { NavComponent } from './page/nav/nav.component';
import { PipsPipe } from './shared/pips.pipe';
import { ComponentsComponent } from './components/components.component';
import { HeaderbarComponent } from './components/headerbar/headerbar.component';
import { ChtmComponent } from './components/chtm/chtm.component';
import { ChartComponent } from './components/chart/chart.component';
import { UploaderComponent } from './components/uploader/uploader.component';
import { RegisterComponent } from './components/register/register.component';
import { PaybackComponent } from './components/payback/payback.component';
import { AskComponent } from './components/ask/ask.component';
import { CalenComponent } from './components/calen/calen.component';
import { TreevComponent } from './components/treev/treev.component';
import { TreeviComponent } from './components/treev/treevi/treevi.component';
import { PmodalComponent } from './components/pmodal/pmodal.component';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProgressComponent } from './components/progress/progress.component';
import { RouterModule, Routes } from '@angular/router';
import { InfocardComponent } from './components/infocard/infocard.component';

export const routes: Routes = [];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    // HomeComponent,
    PageComponent,
    FormyComponent,
    FieldComponent,
    CmodalComponent,
    MenuComponent,
    GridComponent,
    ColumnComponent,
    NavComponent,
    PipsPipe,
    ComponentsComponent,
    HeaderbarComponent,
    ChtmComponent,
    ChartComponent,
    UploaderComponent,
    RegisterComponent,
    PaybackComponent,
    AskComponent,
    CalenComponent,
    TreevComponent,
    TreeviComponent,
    PmodalComponent,
    DashboardComponent,
    ProgressComponent,
    InfocardComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule, // required animations module
    DpDatePickerModule,
    RouterModule.forRoot(routes,{
      anchorScrolling: 'enabled'
    })
  ],
  providers: [PipsPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
